import { closeLoader, openLoader } from '../../../elements/wait_loading/wait_loading'
import { getLazyData } from '../../../utils/get_lazy_data'

import { dispatchHotelListUpdatedEvent } from './list_events'
import { showAvailabilityMessage } from './not_available_message'
import { updatePricesInfo } from '../../../shared/update_prices/update_prices'

function openSpinner() {
  openLoader()
}

function closeSpinner() {
  closeLoader()
}

export function init(PaginationManager) {
  const orderLinks = document.querySelectorAll('.results-order-by .selectable')
  let paginationUpdateEvent
  const IN_RESULTS_PAGE = !!document.querySelector('[data-page-type="bookings"]')
  const AUTO_OFFER_LIST_PRESENT = document.querySelector('.automatic-offer-list')

  function updatePage(response) {
    // MOVER A NIVEL DE CONFIG??
    if (AUTO_OFFER_LIST_PRESENT) {
      document.querySelector('.hotel-list.hotel-list-with-filtering').innerHTML = response.html_replacements
    } else {
      document.querySelector('.hotels-info-with-filtering [data-block-list]').innerHTML = response.html_replacements
    }
    paginationUpdateEvent = paginationUpdateEvent || new Event('pagination:update')
    paginationUpdateEvent.hotelIDs = response.all_ids_hotel_by_order
    document.dispatchEvent(paginationUpdateEvent)

    updatePricesInfo()
  }

  function fetchResults() {
    let offer_type = ''
    if (AUTO_OFFER_LIST_PRESENT) {
      offer_type = $('.automatic-offer-list').data('crsOfferType')
    }

    let offer_id = ''
    if (document.querySelector('html').dataset['pageType'] === 'offer') {
      offer_id = document.querySelector('html').dataset['resourceId']
    }

    const url = PaginationManager.getEndpoint({ for_bookings_page: IN_RESULTS_PAGE, offer_type, offer_id })

    openSpinner()

    getLazyData(url, function (response, isResponseOK) {
      if (!isResponseOK) {
        closeSpinner()
        return
      }
      const data = JSON.parse(response)
      updatePage(data)
      IN_RESULTS_PAGE && IB.booking_results.forceCRSprices()
      closeSpinner()

      if (response?.utag_add_product_impressions) {
        if (IN_RESULTS_PAGE) {
          IB?.utag_ecc_events?.utagLinkProductImpressionPaginationSearch(
            JSON.parse(response.utag_add_product_impressions),
            PaginationManager.getCurrentPage()
          )
        } else {
          IB?.utag_eec_events?.utagLinkProductImpressionPagination(
            JSON.parse(response.utag_add_product_impressions),
            PaginationManager.getCurrentPage()
          )
        }
      }

      if (AUTO_OFFER_LIST_PRESENT) {
        //Event for reset counters in automatic offers
        // NAMESPACE PARA ESTE EVENTO PLS
        const orderResultsEvent = new Event('orderResultsEvent')
        document.dispatchEvent(orderResultsEvent)
      }

      // Update currencies as updateDependencies is not being called within this getLazyData
      IB.currencyForm.forceUpdate()

      IB.lazyImg.addImgToObserver($('.hotels-info-with-filtering'))

      // Add not-availables hotels message
      showAvailabilityMessage()

      dispatchHotelListUpdatedEvent()
    })
  }

  orderLinks.forEach(link => {
    link.addEventListener('click', function () {
      PaginationManager.updateState({ order: link.dataset.orderType })
      fetchResults()
    })
  })
}
